'use client'

import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/view/components/ui/table'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRemoteClientPost } from '../../../configs/http-client'
import { CatchMessageError } from '../../../remote/catch-message-error'
import { ListSellMember } from '../../../remote/types/list-sell-member'
import { CardInfoSelectMember } from '../../components/card-info-select-member'
import { PaginationCashfit } from '../../components/pagination-cashfit'
import { convertParamsToJson, useCashfitParams } from '../../hooks/use-params'
import { formatToBRL } from '../../utils/formatCurrency'

export default function PaymentsTab({ id }: { id: string | undefined | null }) {
  const { httpClientPost } = useRemoteClientPost()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(false)
  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))

  useEffect(() => {
    if (id && !loading) {
      setLoading(true)
      httpClientPost('/relatorios/financeiro/vendas', { alunoId: id })
        .then(setData)
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }, [id, params])

  const calculateTotal = (cart: any) => {
    const productsTotal = cart.produtos.reduce((total: any, item: any) => total + item.quantidade * item.valor, 0)
    const servicesTotal = cart.servicos.reduce((total: any, item: any) => total + item.valor, 0)
    const plansTotal = cart.plano.reduce((total: any, item: any) => total + item.valor, 0)

    return productsTotal + servicesTotal + plansTotal || 0
  }

  const backToStudents = () => setParams({ tabSelected: 'studants' as any })

  if (!params.get('tabContentId')) return <CardInfoSelectMember backToStudents={backToStudents} />

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-medium">Histórico</h2>
      </div>

      <div className="rounded-md border">
        <div className="h-[calc(100vh-300px)] overflow-y-auto]">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead className="">id</TableHead>
                {/* <TableHead>Descrição</TableHead> */}
                <TableHead>Canal</TableHead>
                <TableHead className="text-center">Valor Venda</TableHead>
                <TableHead className="text-center">Valor Pago</TableHead>
                <TableHead className="text-center">Valor em Aberto</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {data?.data.data.content.map((item: ListSellMember) => (
                <TableRow key={item.id}>
                  <TableCell>{item.id}</TableCell>
                  {/* <TableCell>{''}</TableCell> */}
                  <TableCell>{item.origem === 'VENDA_RAPIDA' ? 'Venda Rápida ' : 'Venda'}</TableCell>
                  <TableCell className="text-center">{formatToBRL(calculateTotal(item.cestaCompra))}</TableCell>
                  <TableCell className="text-center">{formatToBRL(calculateTotal(item.cestaCompra))}</TableCell>
                  <TableCell className="text-center">{formatToBRL('0')}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
        <PaginationCashfit data={data?.data.data} labelItem="vendas" />
      </div>
    </div>
  )
}
